module.exports = __webpack_public_path__ + "media/images/logo_ag2R-71bcfa58.png";